/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import {Modal} from "../../atoms/bootstrap/Modal";
import Block from "../../atoms/layout/Block";
import {FlexRow} from "../../atoms/layout/FlexRow";
import TextColumn from "../products/TextColumn";
import React from "react";

export function ObsoleteProductBody({homepage}) {
   return <Modal.Body className={"ordering-modal__body"}>
        <Block className={"ordering-modal__product-row"} style={FlexRow.styles.center}>
            <Block className={"row p-flex p-flex-wrap "}>
                <TextColumn text={homepage.obsoleteProduct}/>
            </Block>
        </Block>
    </Modal.Body>
}
